import { Dialog, DialogFooter, DialogType, PrimaryButton, DefaultButton } from "@fluentui/react";
import { t } from "i18next";
import React from "react";

interface HoursLimitDialogProps {
  isOpen: boolean;
  horasExcedidas: number;
  onConfirm: () => void;
  onCancel: () => void;
}

const HoursLimitDialog: React.FC<HoursLimitDialogProps> = ({ isOpen, horasExcedidas, onConfirm, onCancel }) => (
  <Dialog
    hidden={!isOpen}
    dialogContentProps={{
      type: DialogType.normal,
      title: t("Límite de horas excedido"),
    }}
    modalProps={{
      isBlocking: true,
    }}
    onDismiss={onCancel}
  >
    <div>
      {t("Estás superando las horas establecidas para este mes. ¿Deseas continuar con la carga de horas?")}
      <br />
      <div style={{ textAlign: "center" }}>
        <strong>
          {t("Total de horas extras permitido por")} <br />{"mes = "} {horasExcedidas.toString().split(":")[0]} {"hrs"}
        </strong>
      </div>
    </div>

    <DialogFooter>
      <PrimaryButton onClick={onConfirm} text={t("Continuar")} />
      <DefaultButton onClick={onCancel} text={t("Cancelar")} />
    </DialogFooter>
  </Dialog>
);

export default HoursLimitDialog;